
export const MODAL_LOADER_MIN_VISIBLE_MS = 200;

export async function waitForMinModalLoaderVisible(
  startedAt: number
): Promise<void> {
  const elapsed = Date.now() - startedAt;
  if (elapsed >= MODAL_LOADER_MIN_VISIBLE_MS) return;
  await new Promise<void>((resolve) =>
    setTimeout(resolve, MODAL_LOADER_MIN_VISIBLE_MS - elapsed)
  );
}
